<template>
  <pre_input :value="value" :label="label" :md="md" :tag="c_tag" :view_only="view_only">
    <div style="text-align: center;">
      <span class="label">Priority:</span>
      <span @click="()=>priority_dialog=true">
        <fs1-tooltip>
          Para más información sobre la prioridad de hallazgos, presionar (?)
        </fs1-tooltip>
      </span>
      <ul class="statusFilter mt-2">
        <li
          v-for="(item, i) in priorities"
          :key="i"
          :class="[priority_colors[item],model.find(i => i === item) && `selected`,dark_t&&'dark_t']"
          @click="toggleItems(model, item)">
          {{item}}
        </li>
      </ul>
    </div>
    <priority_modal :dialog.sync="priority_dialog" :edit="false"/>
  </pre_input>
</template>
<script>
import priority_modal from '@/components/modals/priority.vue';
import filter_rq from './filter_rq';
import {  priority_colors } from '@/objects/general.js'; 
import pre_input_js from '@/components/mixins/pre_input';
export default {
  props:{
    f_key:{},
  },
  mixins: [ filter_rq, pre_input_js ],
  components:{priority_modal},
  data(){
    return {
      priority_colors,
      priority_dialog:false,
      model: [],
      multiple: true,
      reset_on_value_change:true,
      filter_rq_type:['>'],
      getted:false,
    }
  },
  computed: {
    dashboard_actions_priority(){ return this.$store.getters.dashboard_actions_priority },
    priorities() { 
      const ps = this.dashboard_actions_priority.map(m => m.priority);
      if (ps.length) this.getted = true;
      return ps
    },
    k_f(){ return this.f_key || `ae__priority` },
    c_value_key() {return this.value_key || this.item_key},
  },
  watch: {
    'getted'(){ if (!this.value) this.model = [...this.priorities] }
  },
  created(){
    if (this.getted) this.model = [...this.priorities]
    else this.model = this.value || [];
  },
  methods: {
    toggleItems(items, item) {
      items.find(i => i === item) ? items.splice(items.indexOf(item), 1) : items.push(item);
      this.upd();
    },
    set_model() { this.model = this.value || [] },
    upd(){
      this.$emit('update:value', this.model);
      const ex_f = {};
      ex_f[this.k_f] = this.model;
      this.pre_get(ex_f,this.k_f);
      this.get_rq(ex_f);
    },
    then_get_rows(r) { return r },
  },
};
</script>
<style scoped>
  .statusFilter{
    list-style: none;
    padding: 0;
  }
  .statusFilter > li{
    text-decoration: line-through;
    cursor: pointer;
    border-radius: 3px;
    background-color: none;
    color: black;
    display: inline;
    padding: 4px 14px 4px 14px;
    margin-right: 5px;
  }
  .statusFilter > li.selected{
    color: white;
    text-decoration: none;
  }
</style>